import { render, staticRenderFns } from "./AirlinePackage.vue?vue&type=template&id=f80e948c&"
import script from "./AirlinePackage.vue?vue&type=script&lang=js&"
export * from "./AirlinePackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports